import axiosRequest from '@/utils/axios-default-request';


/**
 * 供应商项目列表  getProjectList  supUserId
获取项目详情  getProgectDetail projectId
 */

//获取供应商项目列表
 let getProjectList = (data) =>axiosRequest.postBody('/supinterface/getProjectList',data);



//获取项目详情
let getProgectDetail = (data) =>axiosRequest.postBody('/supinterface/getProgectDetail',data);




export default{
    getProjectList, //获取供应商项目列表
    getProgectDetail,//获取项目详情
}